/**
 * Environment configuration helper
 * Handles differences between test and runtime environments
 */

interface EnvironmentConfig {
  API_URL: string
  API_POSTULACIONES_URL: string
  API_POSTULANTES_URL: string
  API_CLOSE_URL: string
  API_STATUS_URL: string
}

/**
 * Get environment variable safely
 */
function getEnvVar(key: string): string {
  // In test environment (Jest), use process.env
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'test') {
    return process.env[key] || ''
  }

  // Check if we're in a Node.js environment (like Jest)
  if (typeof window === 'undefined') {
    return process?.env?.[key] || ''
  }

  // In browser environment, use import.meta.env
  try {
    // @ts-ignore - import.meta.env is available in Vite
    return import.meta.env[key] || ''
  } catch {
    // Fallback for environments that don't support import.meta
    return process?.env?.[key] || ''
  }
}

/**
 * Get all environment configuration
 */
export function getEnvironmentConfig(): EnvironmentConfig {
  // Get the base API URL - try both VITE_API_URL and VITE_API_BASE_URL for compatibility
  const baseApiUrl = getEnvVar('VITE_API_URL') || getEnvVar('VITE_API_BASE_URL')

  return {
    API_URL: baseApiUrl,
    API_POSTULACIONES_URL: `${baseApiUrl}/postulaciones`,
    API_POSTULANTES_URL: `${baseApiUrl}/postulantes`,
    API_CLOSE_URL: `${baseApiUrl}/solicitudes-cierre`,
    API_STATUS_URL: `${baseApiUrl}/postulantes-estado`,
  }
}
